import type { AdminServices } from '../../adminContracts';
import { adminCategories, adminInventory, adminProducts } from './catalog';
import { adminBanners, adminCampaigns, adminCoupons, adminOffers } from './marketing';
import { adminLoyalty, adminReferrals, adminWallet } from './retention';
import { adminCustomers, adminOrders } from './sales';
import { adminStore, adminSystem } from './settings';
import { adminAnalytics, adminDashboard, adminSession } from './insights';

export const mockAdminServices: AdminServices = {
  session: adminSession,
  dashboard: adminDashboard,
  products: adminProducts,
  categories: adminCategories,
  inventory: adminInventory,
  orders: adminOrders,
  customers: adminCustomers,
  coupons: adminCoupons,
  banners: adminBanners,
  offers: adminOffers,
  campaigns: adminCampaigns,
  wallet: adminWallet,
  loyalty: adminLoyalty,
  referrals: adminReferrals,
  store: adminStore,
  system: adminSystem,
  analytics: adminAnalytics,
};
